(function () {
  try {
    const isMobile = window.innerWidth < 768;
    const domain = window.ogl_api_base_url;

    if (!domain) {
      throw new Error('OGL API base URL is unavailable');
    }

    // 工具函数：提取页面上所有产品ID,排除LP页面的置顶商品
    function extractProductIds() {
      const productElements = document.querySelectorAll(
        "[data-product-options]:not([data-is-top])"
      );
      const productIds = [];

      productElements.forEach((element) => {
        const dataOptions = element.getAttribute("data-product-options");
        if (dataOptions) {
          try {
            // 解析 data-product-options 属性值，提取其中的id
            const options = JSON.parse(dataOptions);
            if (options && options.id) {
              productIds.push(options.id);
            }
          } catch (e) {
            window.report_faro({
              file_name: 'assets/ab-test.js',
              func_name: 'extractProductIds',
              desc: `Failed to parse product options: ${dataOptions}`,
              error: e
            });
          }
        }
      });

      return [...new Set(productIds)]; // 去重
    }

    // 工具函数：调用API获取AB测试配置
    async function fetchAbTestConfig() {
      try {
        const userId = window.ogl_uid;
        const t = "aSoYWIvKQMjijVbFx1Uz";

        if (!userId) {
          window.report_faro({
            file_name: 'assets/ab-test.js',
            func_name: 'fetchAbTestConfig',
            desc: 'User ID not found',
            error: 'window.ogl_uid is missing'
          });
          return [];
        }

        const productIds = extractProductIds();
        if (productIds.length === 0) {
          return [];
        }


        const apiUrl = `${domain}/api/v1/ab-test-picture-group/get-ab-test-picture-user?user_id=${encodeURIComponent(
          userId
        )}&product_ids=${productIds.join(",")}&site_id=${window.ogl_config.site?.id}`;

        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            token: t,
            "Content-Type": "application/json",
          },
        });
        const result = await response.json();

        if (result.code === 200 && result.data) {
          return result.data;
        } else {
          window.report_faro({
            file_name: 'assets/ab-test.js',
            func_name: 'fetchAbTestConfig',
            desc: 'API returned an error',
            error: JSON.stringify(result)
          });
          return [];
        }
      } catch (error) {
        window.report_faro({
          file_name: 'assets/ab-test.js',
          func_name: 'fetchAbTestConfig',
          desc: 'Failed to fetch A/B test configuration',
          error: error
        });
        return [];
      }
    }

    function addWidthParamToImageUrl(url, width = 600) {
      try {
        // 处理空字符串或无效 URL
        if (!url || typeof url !== 'string') {
          return url;
        }

        // 使用 URL API 解析（支持完整 URL）
        const urlObj = new URL(url);

        // 添加或覆盖 width 参数
        urlObj.searchParams.set('width', width);

        return urlObj.toString();

      } catch (error) {
        window.report_faro({
          file_name: 'assets/ab-test.js',
          func_name: 'addWidthParamToImageUrl',
          desc: 'Failed to add the image width parameter',
          error: error
        });
        return url;
      }
    }

    document.addEventListener("DOMContentLoaded", function () {
      const pathname = location.pathname;

      // 2. 通过API获取AB测试配置
      async function initAbTestWithApi() {
        const availableProducts = await fetchAbTestConfig();

        // 如果为空，不进行 ab test
        if (availableProducts.length === 0) {
          return;
        }

        initAbTest({
          pathname,
          availableProducts: availableProducts?.items,
          Shopify,
          isMobile,
        });
      }

      function initAbTest({ pathname, availableProducts, Shopify, isMobile }) {
        availableProducts?.forEach((pd) => {
          const {
            shopify_product_id,
            image_url,
            group_id: abGroup,
            version,
            image_id,
          } = pd;
          // 找到产品在 dom 中对应的元素
          const $pdItem = $(`[data-product-options*="${shopify_product_id}"]`);
          // 给元素打上一个正在进行 ab test 的标记
          $pdItem.attr("data-ab-test-id", shopify_product_id);
          $pdItem.attr("data-ab-test-imgUrl", addWidthParamToImageUrl(image_url));
          $pdItem.attr("data-ab-test-group", abGroup);
          $pdItem.attr("data-ab-test-version", version);
          $pdItem.attr("data-ab-test-imageId", image_id);
        });

        // 统计曝光、点击
        if (Shopify) {
          // 点击统计
          $(document).on("click", "a", function () {
            const $parent = $(this).closest("[data-ab-test-id]");
            const abTestId = $parent.attr("data-ab-test-id");
            const abGroup = $parent.attr("data-ab-test-group");
            const abVersion = $parent.attr("data-ab-test-version");
            const imageId = $parent.attr("data-ab-test-imageId");
            const selectedIndex = $parent
              .find(".t4s-pr-color__item.is-swatch--selected")
              .index();

            // 如果选中的颜色不是第一个，则不统计点击
            if (selectedIndex > 0 || !abTestId) return;

            Shopify.analytics.publish("ab-test", {
              productId: abTestId,
              abGroup,
              type: "click",
              platform: !isMobile ? "pc" : "mobile",
              abVersion,
              imageId,
              customerId: window.customer_id || "",
            });
          });

          // 曝光统计
          // 1. 获取所有带有 data-ab-test-id 属性的元素
          const elements = document.querySelectorAll("[data-ab-test-id]");

          // 2. 创建 IntersectionObserver 实例
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  const element = entry.target;
                  const productId = element.dataset.abTestId;

                  // 找到对应的 B 版图片信息
                  const productB = availableProducts.find(
                    (pd) => pd.shopify_product_id == productId
                  );

                  // 如果没有找到对应的产品配置，跳过处理
                  if (!productB) {
                    window.report_faro({
                      file_name: 'assets/ab-test.js',
                      func_name: 'initAbTest',
                      desc: 'Product configuration not found',
                      error: `productId: ${productId}`
                    });
                    return;
                  }

                  // 替换主图图片
                  const {
                    image_url: imgUrl,
                    group_id: abGroup,
                    version: abVersion,
                    image_id: imageId,
                  } = productB;
                  // 找到产品在 dom 中对应的元素
                  const $pdItem = $(element);


                  // 使用指定图片作为 B 版图片
                  if (imgUrl) {
                    const $img = $pdItem.find("img[data-pr-img]");

                    const replaceImgSrc = function () {
                      if ($img) {
                        $img.attr({
                          src: addWidthParamToImageUrl(imgUrl, 600),
                          srcset: addWidthParamToImageUrl(imgUrl, 600),
                          "data-srcset": addWidthParamToImageUrl(imgUrl, 600),
                        });
                      } else {
                        window.report_faro({
                          file_name: 'assets/ab-test.js',
                          func_name: 'replaceImgSrc',
                          desc: 'Image element not found',
                          error: `productId: ${productId}`
                        });
                      }
                    };

                    // 防止曝光前，图片已经展示过了，此时不会出发图片的变更
                    // 直接先替换一次
                    replaceImgSrc();

                    // 使用 observer 监听一下图片,当图片发生变化的时候，替换图片
                    const imgObserver = new DOMChangeObserver(
                      $img[0],
                      (mutation) => {
                        replaceImgSrc();
                        imgObserver.disconnect();
                      }
                    );
                    imgObserver.observe();
                  }

                  // 3. 采集曝光数据
                  Shopify.analytics.publish("ab-test", {
                    productId,
                    abGroup,
                    type: "impression",
                    platform: !isMobile ? "pc" : "mobile",
                    abVersion,
                    imageId,
                    customerId: window.customer_id || "",
                  });

                  // 4. 取消观察该元素（确保只触发一次）
                  observer.unobserve(element);
                }
              });
            },
            {
              // 5. 配置选项：当元素进入视窗多少比例时触发
              threshold: 0.1,
            }
          );

          // 6. 开始观察所有目标元素，且
          // 防止重复监听同一元素
          elements.forEach((ele) => {
            // 使用自定义属性标记已监听的元素，避免重复监听导致回调多次执行
            if (!ele.hasAttribute("data-ab-observed")) {
              observer.observe(ele);
              ele.setAttribute("data-ab-observed", "true");

              const abTestId = ele.dataset.abTestId;
            }
          });
        } else {
          window.report_faro({
            file_name: 'assets/ab-test.js',
            func_name: 'initAbTest',
            desc: 'Unable to publish A/B test analytics',
            error: 'Shopify analytics is unavailable'
          });
        }
      }

      // 初始化AB测试
      initAbTestWithApi();

      // 处理无限滚动的情况 - 监听产品列表变化
      const pdsTarget = document.querySelector(".t4s-products");

      if (pdsTarget) {
        const pdsObserver = new MutationObserver(async (mutations) => {
          let hasNewProducts = false;

          mutations.forEach((mutation) => {
            if (
              mutation.type === "childList" &&
              mutation.addedNodes.length > 0
            ) {
              // 检查是否有新的产品节点添加
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  const hasProductOptions =
                    node.querySelector &&
                    node.querySelector("[data-product-options]");
                  if (
                    hasProductOptions ||
                    node.hasAttribute?.("data-product-options")
                  ) {
                    hasNewProducts = true;
                  }
                }
              });
            }
          });

          if (hasNewProducts) {
            // 重新获取配置并初始化AB测试
            await initAbTestWithApi();
          }
        });

        // 配置：监听子元素变化，支持无限滚动
        pdsObserver.observe(pdsTarget, {
          childList: true, // 监听子元素变化
          subtree: true, // 监听所有后代元素变化
          attributes: false, // 不监听属性变化
          characterData: false, // 不监听文本内容变化
        });
      } else {
        window.report_faro({
          file_name: 'assets/ab-test.js',
          func_name: 'DOMContentLoaded',
          desc: 'Product list element not found',
          error: 'Missing element: .t4s-products'
        });
      }
    });

    /**
     * 监听指定类名元素变化的观察者（无重试逻辑）
     * @param {Object} targetElement - 要监听的元素类名
     * @param {Function} callback - 变化时执行的回调函数
     */
    class DOMChangeObserver {
      constructor(targetElement, callback, debounceTime = 200) {
        this.targetElement = targetElement;
        this.callback = callback;
        this.debounceTime = debounceTime;
        this.observer = null;
        this.debounceTimer = null;
      }

      // 默认的观察配置
      static getDefaultObserverOptions() {
        return {
          childList: true, // 监听子元素变化
          subtree: true, // 监听所有后代元素
          characterData: true, // 监听文本内容变化
          attributes: true, // 监听属性变化
        };
      }

      // 处理变化的回调
      handleMutation = (mutationsList) => {
        for (const mutation of mutationsList) {
          if (
            mutation.type === "childList" ||
            mutation.type === "characterData" ||
            (mutation.type === "attributes" &&
              mutation.attributeName === "class")
          ) {
            // 清除现有计时器
            clearTimeout(this.debounceTimer);
            // 设置新的计时器
            this.debounceTimer = setTimeout(() => {
              this.callback();
              this.disconnect();
            }, this.debounceTime);
            break; // 检测到变化后跳出循环
          }
        }
      };

      // 开始观察
      observe() {
        this.disconnect(); // 先停止现有观察

        if (this.targetElement) {
          this.observer = new MutationObserver(this.handleMutation);
          this.observer.observe(
            this.targetElement,
            DOMChangeObserver.getDefaultObserverOptions()
          );
        } else {
          window.report_faro({
            file_name: 'assets/ab-test.js',
            func_name: 'DOMChangeObserver.observe',
            desc: 'Mutation observer target not found',
            error: 'targetElement is missing'
          });
        }
      }

      // 停止观察
      disconnect() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
        clearTimeout(this.debounceTimer);
      }
    }
  } catch (e) {
    window.report_faro({
      file_name: 'assets/ab-test.js',
      func_name: 'init',
      desc: 'A/B test initialization failed',
      error: e
    });

    // 使用可选链操作符安全地发送错误统计
    Shopify?.analytics?.publish("ab-test-error", {
      errorMsg: e.message,
      customerId: window.customer_id || "",
    });
  }
})();
